<template>
  <v-container v-if="shiftModel">
    <NormalInput
      :id="props.id"
      class="mb-4"
      field="name" />

    <NormalInput
      :id="props.id"
      class="mb-4"
      field="description" />
  </v-container>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useSpaceStore } from "@/stores/spaceStore";
import NormalInput from "@/components/Elements/NormalInput.vue";

const spaceStore = useSpaceStore();

const shiftModel = ref(null);

const props = defineProps({
  id: {
    type: String,
    required: true
  }
});

onMounted(() => {
  shiftModel.value = spaceStore.getElement(props.id);
});
</script>
